import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Chift\GetCompanyConnexionMetadata::__invoke
* @see app/Http/Controllers/Chift/GetCompanyConnexionMetadata.php
* @route '/api/company/{company}/chift/connexion-metadata'
*/
const GetCompanyConnexionMetadata = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCompanyConnexionMetadata.url(args, options),
    method: 'get',
})

GetCompanyConnexionMetadata.definition = {
    methods: ["get","head"],
    url: '/api/company/{company}/chift/connexion-metadata',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Chift\GetCompanyConnexionMetadata::__invoke
* @see app/Http/Controllers/Chift/GetCompanyConnexionMetadata.php
* @route '/api/company/{company}/chift/connexion-metadata'
*/
GetCompanyConnexionMetadata.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return GetCompanyConnexionMetadata.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Chift\GetCompanyConnexionMetadata::__invoke
* @see app/Http/Controllers/Chift/GetCompanyConnexionMetadata.php
* @route '/api/company/{company}/chift/connexion-metadata'
*/
GetCompanyConnexionMetadata.get = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCompanyConnexionMetadata.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Chift\GetCompanyConnexionMetadata::__invoke
* @see app/Http/Controllers/Chift/GetCompanyConnexionMetadata.php
* @route '/api/company/{company}/chift/connexion-metadata'
*/
GetCompanyConnexionMetadata.head = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetCompanyConnexionMetadata.url(args, options),
    method: 'head',
})

export default GetCompanyConnexionMetadata